import {
  SET_INGREDIENTS,
  DELETE_INGREDIENT,
  SET_INGREDIENT_NUTRIENTS,
} from '../actions/ingredient';

let initialState = {
  ingredientsData: [],
  ingredientNutrients: null,
};

const ingredient = (state = initialState, action) => {
  switch (action.type) {
    case SET_INGREDIENTS:
      return {
        ...state,
        ingredientsData: action.payload,
      };

    case DELETE_INGREDIENT: {
      const { ingredientsData } = state;
      const newIngredientsData = ingredientsData.filter((ingredientData) => {
        return ingredientData.id !== action.payload;
      });

      return {
        ...state,
        ingredientsData: newIngredientsData,
      };
    }

    case SET_INGREDIENT_NUTRIENTS: {
      return {
        ...state,
        ingredientNutrients: action.payload,
      };
    }

    default:
      return state;
  }
};

export default ingredient;
